import * as React from "react";
import { useLink } from "@grandvisionhq/frk-routing";
import { useFeatureToggles, useDispatch } from "@grandvisionhq/state";
import { useGetFrame } from "../../hooks/hooks/use-get-frame.js";
import { startPrescriptionGlassesConfiguration } from "../../state/state/actions.js";
const RxGlassesConfiguratorContext = React.createContext(
  {}
);
const useRxGlassesConfiguratorContext = () => React.useContext(RxGlassesConfiguratorContext);
const RxGlassesConfiguratorProvider = ({
  children,
  opticianForm,
  configuratorDocument,
  frame: existingFrame,
  frameSlug,
  frameSku,
  rxEntryTypes,
  id
}) => {
  const bookAppointmentLink = useLink({ route: "appointments.book" });
  const bookAppointmentRoute = bookAppointmentLink?.href;
  const frame = useGetFrame({ existingFrame, frameSlug });
  const { isPrescriptionGlassesConfiguratorValidationStepEnabled: isExtraValidationStepEnabled } = useFeatureToggles();
  let preselectedPrescriptionEntry;
  if (rxEntryTypes?.[0]) {
    preselectedPrescriptionEntry = rxEntryTypes[0].key;
  }
  if (!rxEntryTypes || rxEntryTypes.length === 0) {
    console.error(
      `ERROR: No prescription entry types configured in the CMS for RxConfigurator with id: "${id}". These MUST be configured for the Prescription Entry Selection step to work correctly.`
    );
  }
  const value = React.useMemo(
    () => ({
      opticianForm,
      configuratorDocument,
      isExtraValidationStepEnabled,
      id
    }),
    [opticianForm, configuratorDocument, isExtraValidationStepEnabled, id]
  );
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (!frame) {
      return;
    }
    dispatch(
      startPrescriptionGlassesConfiguration({
        frame,
        frameSku,
        isExtraValidationStepEnabled,
        preselectedPrescriptionEntry,
        rxEntryTypes,
        bookAppointmentRoute
      })
    );
  }, [dispatch, frame]);
  return /* @__PURE__ */ React.createElement(RxGlassesConfiguratorContext.Provider, { value }, children);
};
export {
  RxGlassesConfiguratorContext,
  RxGlassesConfiguratorProvider,
  useRxGlassesConfiguratorContext
};
//# sourceMappingURL=RxGlassesConfiguratorContext.js.map
